<template>
  <div class="page configurare">
    <ErrorAlert :message="errorMessage" @clear-error="clearMessage" />
    <SuccessAlert :message="successMessage" @clear-error="clearMessage" />

    <PageHeader
      title="Configurare"
      subtitle="Tipuri de echipament, cauze, circuitele de aprobare, catalogul de modele, departamente și săli. Demersurile depuse nu se schimbă: fiecare își păstrează datele cu care a fost depus."
      icon="mdi-cog-outline"
    />

    <div class="page-body">
      <section class="panel">
        <v-tabs
          v-model="tab"
          show-arrows
          color="primary"
          slider-size="3"
          class="cfg-tabs"
          aria-label="Secțiunile configurării"
        >
          <v-tab v-for="t in tabs" :key="t.key" :tab-value="t.key">
            <v-icon small class="mr-2">{{ t.icon }}</v-icon>{{ t.label }}
          </v-tab>
        </v-tabs>
        <keep-alive>
          <component :is="current.component" @success="showSuccess" @error="showError" />
        </keep-alive>
      </section>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/layout/PageHeader.vue";
import ErrorAlert from "@/components/alerts/ErrorAlert.vue";
import SuccessAlert from "@/components/alerts/SuccessAlert.vue";
import TypesTab from "./TypesTab.vue";
import CausesTab from "./CausesTab.vue";
import CircuitsTab from "./CircuitsTab.vue";
import CatalogTab from "./CatalogTab.vue";
import DepartmentsTab from "./DepartmentsTab.vue";
import LocationsTab from "./LocationsTab.vue";
import LogTab from "./LogTab.vue";
import "./configurare.css";

// ?tab= keys (Echipamente links to /configurare?tab=catalog)
const TABS = [
  { key: "tipuri", label: "Tipuri echipament", icon: "mdi-shape-outline", component: TypesTab },
  { key: "cauze", label: "Cauze", icon: "mdi-format-list-bulleted-type", component: CausesTab },
  { key: "circuite", label: "Circuite aprobare", icon: "mdi-sitemap-outline", component: CircuitsTab },
  { key: "catalog", label: "Catalog modele", icon: "mdi-tag-multiple-outline", component: CatalogTab },
  { key: "departamente", label: "Departamente", icon: "mdi-domain", component: DepartmentsTab },
  { key: "locatii", label: "Locații", icon: "mdi-map-marker-outline", component: LocationsTab },
  { key: "jurnal", label: "Jurnal", icon: "mdi-history", component: LogTab },
];

export default {
  name: "ConfigurarePage",
  components: { PageHeader, ErrorAlert, SuccessAlert },
  data() {
    return {
      tabs: TABS,
      tab: this.tabFromRoute(),
      errorMessage: "",
      successMessage: "",
      shownAt: 0,
    };
  },
  computed: {
    current() {
      return TABS.find((t) => t.key === this.tab) || TABS[0];
    },
  },
  watch: {
    tab(key) {
      if (this.$route.query.tab !== key) {
        this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {});
      }
    },
    "$route.query.tab"() {
      const key = this.tabFromRoute();
      if (key !== this.tab) this.tab = key;
    },
  },
  methods: {
    tabFromRoute() {
      const key = this.$route.query.tab;
      return TABS.some((t) => t.key === key) ? key : TABS[0].key;
    },
    // The alerts clear themselves with a timer started by the previous message; changes made one after
    // another would lose their toast to that timer, so a clear only counts once the current one had its time.
    showSuccess(message) {
      this.show("successMessage", message);
    },
    showError(message) {
      this.show("errorMessage", message);
    },
    show(field, message) {
      this.errorMessage = "";
      this.successMessage = "";
      this.shownAt = Date.now();
      // through "" so the same text twice still restarts the alert
      this.$nextTick(() => {
        this[field] = message;
      });
    },
    clearMessage() {
      const age = Date.now() - (this.shownAt || 0);
      if (age < (this.errorMessage ? 4400 : 2900)) return;
      this.errorMessage = "";
      this.successMessage = "";
    },
  },
};
</script>

<style scoped>
.cfg-tabs {
  border-bottom: 1px solid var(--line);
}
.cfg-tabs ::v-deep .v-tab {
  text-transform: none;
  letter-spacing: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--ink-2) !important;
}
.cfg-tabs ::v-deep .v-tab--active {
  color: var(--green-700) !important;
}
</style>
